/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CurrencyWithLatestRateResponseDto } from './CurrencyWithLatestRateResponseDto';
import {
    CurrencyWithLatestRateResponseDtoFromJSON,
    CurrencyWithLatestRateResponseDtoFromJSONTyped,
    CurrencyWithLatestRateResponseDtoToJSON,
    CurrencyWithLatestRateResponseDtoToJSONTyped,
} from './CurrencyWithLatestRateResponseDto';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';

/**
 * 
 * @export
 * @interface CurrencyPaginationResponseDto
 */
export interface CurrencyPaginationResponseDto {
    /**
     * 
     * @type {PaginationDto}
     * @memberof CurrencyPaginationResponseDto
     */
    pagination: PaginationDto;
    /**
     * 
     * @type {Array<CurrencyWithLatestRateResponseDto>}
     * @memberof CurrencyPaginationResponseDto
     */
    items: Array<CurrencyWithLatestRateResponseDto>;
}

/**
 * Check if a given object implements the CurrencyPaginationResponseDto interface.
 */
export function instanceOfCurrencyPaginationResponseDto(value: object): value is CurrencyPaginationResponseDto {
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function CurrencyPaginationResponseDtoFromJSON(json: any): CurrencyPaginationResponseDto {
    return CurrencyPaginationResponseDtoFromJSONTyped(json, false);
}

export function CurrencyPaginationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CurrencyPaginationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pagination': PaginationDtoFromJSON(json['pagination']),
        'items': ((json['items'] as Array<any>).map(CurrencyWithLatestRateResponseDtoFromJSON)),
    };
}

export function CurrencyPaginationResponseDtoToJSON(json: any): CurrencyPaginationResponseDto {
    return CurrencyPaginationResponseDtoToJSONTyped(json, false);
}

export function CurrencyPaginationResponseDtoToJSONTyped(value?: CurrencyPaginationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pagination': PaginationDtoToJSON(value['pagination']),
        'items': ((value['items'] as Array<any>).map(CurrencyWithLatestRateResponseDtoToJSON)),
    };
}

